import { Layout } from '@loadsmart/miranda-react'

import { type BulkRate } from '../../domain/BulkRate'
import { isQuoteExpired } from '../../domain/Quote'
import { type SpotQuote } from '../../domain/SpotQuote'
import { type SpotQuoteStatus } from '../../domain/SpotQuoteStatus'
import { QuoteRateInputFields } from '../QuoteRateInputFields'
import { SubmittedRateValue } from '../SubmittedRateValue'

export type BidRateFieldProps = Readonly<{
  isSubmitted: boolean
  currentFlatRate?: number
  disabled?: boolean
  initialFlatRate: number
  initialPerMileRate: number
  mileage?: number
  onRateChange: (flatRate: number) => void
  submittedAt?: Date
  rateStatus: SpotQuoteStatus
  spotQuote: SpotQuote | BulkRate
}>

export function BulkBidRateField({
  isSubmitted,
  mileage,
  initialFlatRate,
  initialPerMileRate,
  disabled,
  onRateChange,
  currentFlatRate,
  submittedAt,
  rateStatus,
  spotQuote,
}: BidRateFieldProps) {
  const isExpired = isQuoteExpired(spotQuote.quote)
  return (
    <Layout.Stack>
      {!isExpired && (
        <QuoteRateInputFields mileage={mileage} disabled={disabled} onRateChange={onRateChange} />
      )}
      {isSubmitted && (
        <SubmittedRateValue
          initialFlatRate={initialFlatRate}
          initialPerMileRate={initialPerMileRate}
          currentFlatRate={currentFlatRate}
          mileage={mileage}
          submittedAt={submittedAt}
          rateStatus={rateStatus}
        />
      )}
    </Layout.Stack>
  )
}
